export const GET_RECORD_FILE_TICkET =
  'historyFileTicket/GET_RECORD_FILE_TICkET';
export const SET_RECORD_FILE_TICKET =
  'historyFileTicket/SET_RECORD_FILE_TICKET';
export const FETCH_RECORD_FILE_TICKET =
  'historyFileTicket/FETCH_RECORD_FILE_TICKET';
